import React from "react";
import Box from "@mui/material/Box/Box";
import GenieText from "../../../../components/core/genie-text/GenieText";
import { useParams } from "react-router-dom";
import useSplash from "../../../../queries/routes/useSplash";
import GenieSkeleton from "../../../../components/core/genie-skeleton/GenieSkeleton";
import useUser from "../../../../queries/routes/useUser";

function Splash() {
  const { org_id } = useParams();
  const { data, isError } = useSplash(org_id!);
  const { data: user } = useUser();

  const organization = user?.purchasing_organizations.find(
    (org) => org_id === org.organization.id
  );

  // hack to place the loading indicator in the view
  if (!data || isError || !data.logo || !data.splash_image) {
    return <GenieSkeleton height={300} />;
  }

  return (
    <Box
      sx={{
        position: "relative",
        marginBottom: "120px",
      }}
    >
      <Box
        sx={{
          height: "100%",
          width: "100%",
          position: "absolute",
        }}
      >
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"flex-end"}
          height={"100%"}
          marginTop={"120px"}
        >
          <Box sx={{ textAlign: "center" }}>
            <img
              width={"65px"}
              height={"65px"}
              src={data?.logo.cloudinary_url || `/assets/sundaze_logo.png`}
              alt={"Logo"}
            />
            <GenieText fontWeight={"bold"} fontSize={"large"}>
              {organization?.organization.name}
            </GenieText>
            <GenieText style={{ mx: 2 }}>
              {organization?.organization.slogan || ""}
            </GenieText>
          </Box>
        </Box>
      </Box>
      <Box
        style={{
          width: "100%",
          height: "300px",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundImage: `url(${
            data?.splash_image.cloudinary_url || `/assets/splash_sample.png`
          })`,
        }}
      />
    </Box>
  );
}

export default Splash;
